export class User {
  id: string;
  email: string;
  userName: string;
  fullName: string;
  dateTimeOffset: string;
  phoneNumber: string;
  commands: Array<any>;
  created: number;
  isEnabled: boolean;
  isTest: boolean;
  onlineId: string;
  onlineSynchronized: boolean;
  parameters: any;
  phoneNumberConfirmed: boolean;
  roles: Array<string>;
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.ts